import module from '@kendu/ui/module'
import template from './template.html'
import './style.scss'

export class KdCheckboxComponent {
  constructor ($attrs, $element) {
    this.attrs = $attrs
    this.element = $element
    this.ngModel = undefined
  }

  $onInit () {
    this.ngModel.$render = () => this.render.bind(this)
    this.ngModel.$isEmpty = () => this.isEmpty.bind(this)

    this.element.on('click', (ev) => {
      let value = !this.attrs.checked

      this.setValue(value)
      this.ngModel.$setViewValue(value, ev && ev.type)
    })

    /* scope.$watch($attrs.checked, (value) => {
     $attrs.$set("checked", "checked" in $attrs && !!value);
     }); */
  }

  isEmpty (value) {
    return value === false
  }

  render () {
    this.setValue(this.ngModel.$viewValue)
  }

  setValue (value) {
    this.attrs.$set('checked', value)
  }
}

module.component('kdCheckbox', {
  transclude: true,
  template: template,
  controller: KdCheckboxComponent,
  require: {
    ngModel: 'ngModel',
  },
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-checkbox/component.js